module.exports = __webpack_public_path__ + "img/zidar-iso.103729bd.svg";